import React, { useEffect } from 'react';
export default function Logout({ history }) {
    useEffect(() => {
        localStorage.clear();
        window.location = '/login';
    }, []);

    return (<></>)
}
